import { buildImgUrl, ENGLISH_IQ_LANDING_IMG_SLUG } from '@repo/config';
import type { SupportedLocaleType } from '@repo/web-chrome/i18n';
import { areEnglishIqV2SocialAssetsEnabled } from './are-english-iq-v2-social-assets-enabled';

export function buildEnglishIqV2LandingImageUrl(locale: SupportedLocaleType): string {
  return buildImgUrl({
    locale,
    slug: areEnglishIqV2SocialAssetsEnabled() ? ENGLISH_IQ_LANDING_IMG_SLUG : 'home',
    type: 'page',
  });
}
